import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import DiningPage from './pages/DiningPage';
import DiningRoomPage from './pages/DiningRoomPage';
import CafePage from './pages/CafePage';
import KitchenPage from './pages/KitchenPage';
import GolfPage from './pages/GolfPage';
import CartPage from './pages/CartPage';
import HallPage from './pages/HallPage';
import LoungePage from './pages/LoungePage';
import ShopPage from './pages/ShopPage';
import SpaPage from './pages/SpaPage';
import ResidentialPage from './pages/ResidentialPage';
import ResidencesPage from './pages/ResidencesPage';
import CommonAreasPage from './pages/CommonAreasPage';
import PoolsideDiningPage from './pages/PoolsideDiningPage';
import PickleballPage from './pages/PickleballPage';
import SpecialEventsPage from './pages/SpecialEventsPage';
import AboutUsPage from './pages/AboutUsPage';
import SolutionPage from './pages/SolutionPage';
import NoDisplay from './components/NoDisplay';

function App() {
  return (
    <div className="app">
      <NoDisplay />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/residential" element={<Outlet />}>
          <Route index element={<ResidentialPage />} />
          <Route path="residence" element={<ResidencesPage />} />
          <Route path="common" element={<CommonAreasPage />} />
          <Route path="pool" element={<PoolsideDiningPage />} />
        </Route>
        <Route path="/dining" element={<Outlet />}>
          <Route index element={<DiningPage />} />
          <Route path="dining-room" element={<DiningRoomPage />} />
          <Route path="cafe" element={<CafePage />} />
          <Route path="kitchen" element={<KitchenPage />} />
        </Route>
        <Route path="/golf" element={<Outlet />}>
          <Route index element={<GolfPage />} />
          <Route path="cart" element={<CartPage />} />
          <Route path="hall" element={<HallPage />} />
          <Route path="club" element={<LoungePage />} />
          <Route path="shop" element={<ShopPage />} />
        </Route>
        <Route path="/spa" element={<SpaPage />} />
        <Route path="/pickleball" element={<PickleballPage />} />
        <Route path="/special-events" element={<SpecialEventsPage />} />
        <Route path="/solutions/:slug" element={<SolutionPage />} />
        <Route path="/aboutus" element={<AboutUsPage />} />
        <Route path="/aboutus/agilysys" element={<AboutUsPage />} />
      </Routes>
    </div>
  );
}

export default App;
